//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ImpactCard",
  props: {
    src: {
      type: String
    },

    title: {
      type: String,
      default: "Global"
    },

    subtitle: {
      type: String,
      default: "Suggestions"
    },

    counter: {
      type: Number,
      default: 9999
    },

    helper: {
      type: String,
      default: "Impact card"
    }
  },

  data: () => ({}),

  computed: {
    formatted_counter: function () {
      return this._format(String(this.counter));
    }
  },

  methods: {
    _format(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
}
